<template>
  <div class="ticket-detail-wrapper">
    <!-- <display-navigation
      v-show="ticketDetail.ticket"
      :path="spotId === '0' ? '' : 'tickets_list'"
      title="门票详情"
    /> -->
    <van-swipe>
      <van-swipe-item v-for="(item, index) of ticketDetail.slide || []" :key="index">
        <display-ticket-cover :value="item" />
      </van-swipe-item>
    </van-swipe>

    <field-group
      :value="{ ...ticketDetail, left }"
      :united="united"
      @count="handleSetCount"
      @change="handleFieldChange"
    />
    <display-description :value="ticketDetail.explain" class="detailDesc" />
    <submit-bar :price="price * 100" :loading="loading" @submit="handleSubmit" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { getTicketDetail } from '@/api/api-ticket';
import { createOrder } from '@/api/api-user';

import { choosePayment, handelWeChatConfig } from '@/utils/util';

import DisplayTicketCover from '@/components/DisplayTicketCover.vue';
// import DisplayNavigation from '@/components/DisplayNavigation.vue';
import DisplayDescription from '@/components/DisplayDescription.vue';
import FieldGroup from './FieldGroup';
import SubmitBar from './SubmitBar';

export default {
  name: 'TicketDetail',
  components: {
    DisplayTicketCover,
    // DisplayNavigation,
    DisplayDescription,
    FieldGroup,
    SubmitBar,
  },
  data() {
    return {
      form: {},
      loading: false,
      ticketDetail: {},
      left: 999,
    };
  },
  computed: {
    ...mapGetters(['user', 'spotId', 'appPlatform']),
    ticketId() {
      return this.$route.query.id;
    },
    united() {
      return this.$route.query.united;
    },
    price() {
      return ((this.ticketDetail.price || 0) * (this.form.count || 0)).toFixed(2);
    },
    infoNeeded() {
      return this.ticketDetail.message_name === 1;
    },
    // faceNeeded() {
    //   return this.ticketDetail.message_face === 1;
    // },
  },
  async created() {
    try {
      const id = await this.checkTicketId();
      const detail = await getTicketDetail({ id, united: this.united });
      this.ticketDetail = detail;
      if (this.appPlatform === 'isWechat') {
        handelWeChatConfig();
      }
    } catch {
      this.back();
    }
  },
  methods: {
    async checkTicketId() {
      return new Promise((resolve, reject) => (this.ticketId ? resolve(this.ticketId) : reject()));
    },
    back() {
      this.$router.push({ name: 'tickets_list' });
    },
    handleFieldChange(form) {
      this.form = form;
    },
    handleSetCount(val) {
      this.left = val === -1 ? 999 : val;
    },
    async handleSubmit() {
      try {
        const fields = await this.checkFields();
        fields.info = fields.info.map(({ img, ...others }) => {
          return { img: img.replace('data:image/jpeg;base64,', ''), ...others };
        });
        this.loading = true;
        const data = await createOrder(fields, this.united, this.user.nickname);
        if (data.free === 1) {
          this.$router.push('/');
        } else if (data) {
          await choosePayment(data);
          await this.$router.push('/orders_list'); // 成功
        }
      } catch (err) {
        this.$toast.fail(err.message);
      } finally {
        this.loading = false;
      }
    },
    async checkFields() {
      return new Promise((resolve, reject) => {
        // const { tel, date, shop, count, info, image } = this.form;
        const { tel, date, shop, count, info, interval } = this.form;
        if (this.ticketDetail.message_mobile && !tel) reject(new Error('未输入手机号'));
        if (!date) reject(new Error('未选择日期'));
        if (this.ticketDetail.is_time_interval && !interval) reject(new Error('未选择时间段'));
        if (!count) reject(new Error('未选择购票数量'));
        // 实名制
        if (this.infoNeeded) {
          info.forEach(item => {
            try {
              const { name, identityNo } = item;
              if (!name) reject(new Error('未输入姓名'));
              if (!identityNo) reject(new Error('未输入身份证号'));
            } catch {
              reject(new Error('未输入用户信息'));
            }
          });
        }
        // 人脸
        // if (this.faceNeeded) {
        //   if (image.length < count && !this.infoNeeded) reject(new Error('未上传人脸图片'));
        //   if (this.infoNeeded) {
        //     info.forEach(item => {
        //       try {
        //         const { img: infoImg } = item;
        //         if (!infoImg) reject(new Error('未上传人脸图片'));
        //       } catch {
        //         reject(new Error('未输入用户信息'));
        //       }
        //     });
        //   }
        // }
        const uid = window.sessionStorage.getItem('userId');
        resolve({
          tel,
          uid,
          shop,
          date,
          interval,
          info,
          count,
          id: this.ticketId,
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.ticket-detail-wrapper {
  padding-bottom: 50px;
  .amount-wrapper {
    margin: 46px 0;
    text-align: center;
    .amount {
      font-size: 48px;
    }
    .dollar {
      font-size: 32px;
    }
  }
  .balance {
    padding-right: 12px;
  }
  .detailDesc {
    padding: 0 16px;
  }
}
</style>
